import { h } from 'preact';
import { OVERLAY_LAYER } from '../../../common/constants';
import { useDialogContext } from '../../../common/context/DialogContext';
import { useStyles } from '../../../common/hooks';
import { LABEL_AUDIO_ET_SOUS_TITRES } from '../controls/exp/tracks/TracksMenu';
import EcoButton from '../controls/extra/EcoButton';
import EmbedButton from '../controls/extra/EmbedButton';
import Settings from '../controls/extra/Settings';
import SourceButton from '../controls/extra/SourceButton';
import { EXTRA_INFOS_WRAPPER_STYLE } from './styles';

function ExtraInfos() {
  const setStyles = useStyles();
  const dialogCtx = useDialogContext();

  return (
    <div
      style={{
        ...EXTRA_INFOS_WRAPPER_STYLE,
        zIndex: OVERLAY_LAYER + (dialogCtx.dialogOpened && dialogCtx.activeId !== LABEL_AUDIO_ET_SOUS_TITRES ? 2 : 1),
        ...setStyles({
          default: { gap: '12px' },
          'medium+large+extraLarge': { gap: '14px' }
        })
      }}
    >
      <SourceButton />
      <EcoButton />
      <EmbedButton />
      <Settings />
    </div>
  );
}

export default ExtraInfos;
